var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.99 105.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{stroke-linejoin:round;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#fff;}.cls-2,.cls-10{fill:#2c75fb;}.cls-3{fill:url(#linear-gradient-2);}.cls-3,.cls-4{fill-opacity:.44;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:rgba(255,255,255,.2);}.cls-9{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 95.97,
    y1: 69.55,
    x2: 109.98,
    y2: 69.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 53.69,
    x2: 67.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 116.77,
    y1: 29.59,
    x2: 123.56,
    y2: 29.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 116.77,
    y1: 46.12,
    x2: 123.56,
    y2: 46.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 125.04,
    y1: 37.86,
    x2: 131.83,
    y2: 37.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 108.51,
    y1: 37.86,
    x2: 115.3,
    y2: 37.86,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.95,102.84c-10.05,7.62-29.29-12.24-39.26-23.93-2.34-2.75-6.43-3.02-9.19-.71-1.95,1.63-4.46,2.61-7.21,2.61-3.95,0-7.44-2.04-9.44-5.13-1.4-2.16-3.78-3.48-6.35-3.48h-11.01c-2.57,0-4.95,1.32-6.35,3.48-2.01,3.09-5.49,5.13-9.44,5.13-2.74,0-5.25-.98-7.21-2.61-2.77-2.31-6.85-2.03-9.19,.71-9.97,11.69-29.21,31.55-39.26,23.93C-7.92,93.04,10.71,33.87,13.45,25.43c3.46-11.17,13.9-19.34,26.17-19.34H124.35c11.9,0,22.09,7.69,25.85,18.34,0,0,0,.01,.01,.03,.03,.07,.05,.14,.06,.21,.07,.17,.15,.42,.26,.76,2.74,8.44,21.37,67.61,8.42,77.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.44,
    y: 0.5,
    width: 23.32,
    height: 5.59,
    rx: 1.92,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.46,
    y: 0.5,
    width: 23.32,
    height: 5.59,
    rx: 1.92,
    ry: 1.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.98,
    cy: 69.55,
    r: 7.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 60.7,
    cy: 69.55,
    r: 7.01
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.39,51.02c-2.46,0-4.46-2-4.46-4.46v-3.8h-3.8c-2.46,0-4.46-2-4.46-4.46v-.87c0-2.46,2-4.46,4.46-4.46h3.8v-3.8c0-2.46,2-4.46,4.46-4.46h.87c2.46,0,4.46,2,4.46,4.46v3.8h3.8c2.46,0,4.46,2,4.46,4.46v.87c0,2.46-2,4.46-4.46,4.46h-3.8v3.8c0,2.46-2,4.46-4.46,4.46h-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.25,26.2c1.63,0,2.96,1.33,2.96,2.96v5.3h5.3c1.63,0,2.96,1.33,2.96,2.96v.87c0,1.63-1.33,2.96-2.96,2.96h-5.3v5.3c0,1.63-1.33,2.96-2.96,2.96h-.87c-1.63,0-2.96-1.33-2.96-2.96v-5.3h-5.3c-1.63,0-2.96-1.33-2.96-2.96v-.87c0-1.63,1.33-2.96,2.96-2.96h5.3v-5.3c0-1.63,1.33-2.96,2.96-2.96h.87m0-3h-.87c-3.29,0-5.96,2.67-5.96,5.96v2.3h-2.3c-3.29,0-5.96,2.67-5.96,5.96v.87c0,3.29,2.67,5.96,5.96,5.96h2.3v2.3c0,3.29,2.67,5.96,5.96,5.96h.87c3.29,0,5.96-2.67,5.96-5.96v-2.3h2.3c3.29,0,5.96-2.67,5.96-5.96v-.87c0-3.29-2.67-5.96-5.96-5.96h-2.3v-2.3c0-3.29-2.67-5.96-5.96-5.96h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 120.17,
    cy: 29.59,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 120.17,
    cy: 46.12,
    r: 3.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 128.43,
    cy: 37.86,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 111.9,
    cy: 37.86,
    r: 3.4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameDev);
export default __webpack_public_path__ + "static/media/game-dev.f8ca869148c4b1b25db256576351ff1d.svg";
export { ForwardRef as ReactComponent };